import React, {useState} from 'react'
import ReservationEmailField from "./Fields/ReservationEmailField";
import PasswordField from "./Fields/PasswordField";
import {isValidEmail} from "../../config/toolKit";
import {loginAPI} from "../../network/publicCalls/POSTLogin";
import {resetPasswordAPI} from "../../network/publicCalls/POSTResetPassword";

const ReservationLoginPanel = ({
    subsidiaryId,
    onAuthSuccess,
    email,
    onEmailChange,
    showRegistrationSuccess = false,
    embedded = false
}) => {

    const [password, setPassword] = useState("")
    const [authStep, setAuthStep] = useState("login")
    const [isLoginLoading, setIsLoginLoading] = useState(false)
    const [isResetLoading, setIsResetLoading] = useState(false)
    const [errorMessage, setErrorMessage] = useState("")
    const [resetSuccessMessage, setResetSuccessMessage] = useState("")

    const onLogin = async (e) => {
        e.preventDefault()
        if (!password) return;

        setIsLoginLoading(true)
        setErrorMessage("")
        setResetSuccessMessage("")

        try {
            const {token} = await loginAPI({
                subsidiaryId,
                email,
                password
            })

            if (token) {
                if (typeof window !== "undefined" && window.localStorage) {
                    try {
                        window.localStorage.setItem('token', token)
                    } catch (ex) {
                        // Auth session continues in memory even if storage is unavailable.
                    }
                }

                onAuthSuccess(token)
            }

        } catch (ex) {
            setErrorMessage("Inloggen is mislukt. Controleer je e-mailadres en wachtwoord en probeer opnieuw.")
        } finally {
            setIsLoginLoading(false)
        }
    }

    const onOpenResetPasswordStep = () => {
        setAuthStep("reset")
        setErrorMessage("")
        setResetSuccessMessage("")
    }

    const onBackToLoginStep = () => {
        setAuthStep("login")
        setPassword("")
        setErrorMessage("")
        setResetSuccessMessage("")
    }

    const onResetPassword = async (e) => {
        e.preventDefault()
        if (!isValidEmail(email)) return

        setIsResetLoading(true)
        setErrorMessage("")
        setResetSuccessMessage("")

        try {
            const response = await resetPasswordAPI({
                subsidiaryId,
                email,
            })

            if (response?.error) {
                throw new Error(response.error?.message || "reset_password_error")
            }

            setResetSuccessMessage("Als dit e-mailadres bekend is, hebben we een resetlink verstuurd.")
        } catch (error) {
            setErrorMessage("Wachtwoordherstel is mislukt. Probeer het opnieuw.")
        } finally {
            setIsResetLoading(false)
        }
    }

    return (
        <div className={embedded ? "kav-panel kav-auth-panel" : "kav-panel"}>
            <h2 className="kav-h2">{embedded ? "Inloggen" : "Al eerder gehuurd? Log dan in"}</h2>
            <form onSubmit={authStep === "reset" ? onResetPassword : onLogin}>
                {
                    showRegistrationSuccess && (
                        <div className="kav-callout kav-auth-success">
                            Registratie afgerond. Log in om verder te gaan met je reservering.
                        </div>
                    )
                }

                <ReservationEmailField value={email} onChange={(e) => onEmailChange(e.target.value)}/>

                {
                    authStep === "login" && (
                        <PasswordField label="Wachtwoord" value={password}
                                       onChange={(e) => setPassword(e.target.value)}
                                       showVisibilityToggle/>
                    )
                }

                {
                    authStep === "reset" && (
                        <div className="kav-callout">
                            Vul je e-mailadres in. We sturen een link om je wachtwoord opnieuw in te stellen.
                        </div>
                    )
                }

                {
                    errorMessage && (
                        <div className="kav-callout kav-auth-error">
                            {errorMessage}
                        </div>
                    )
                }

                {
                    resetSuccessMessage && (
                        <div className="kav-callout kav-auth-success">
                            {resetSuccessMessage}
                        </div>
                    )
                }

                <div className="mt-3">
                    {
                        authStep === "login" ?
                            <div className="kav-auth-actions">
                                <button
                                    type="button"
                                    onClick={onOpenResetPasswordStep}
                                    disabled={isLoginLoading}
                                    className="kav-step-actions__btn kav-step-actions__btn--ghost kav-auth-actions__link"
                                >
                                    Wachtwoord vergeten
                                </button>
                                <button
                                    disabled={!isValidEmail(email) || password.length < 6 || isLoginLoading}
                                    className="kav-step-actions__btn kav-step-actions__btn--primary"
                                    type="submit"
                                >
                                    {isLoginLoading && <span className="kav-spinner kav-spinner--light" aria-hidden="true"></span>}
                                    {isLoginLoading ? "Inloggen..." : "Login"}
                                    {!isLoginLoading && <i className="bi bi-chevron-right" aria-hidden="true"></i>}
                                </button>
                            </div>
                            :
                            <div className="kav-auth-actions">
                                <button
                                    type="button"
                                    onClick={onBackToLoginStep}
                                    disabled={isResetLoading}
                                    className="kav-step-actions__btn kav-step-actions__btn--ghost"
                                >
                                    Terug
                                </button>
                                <button
                                    disabled={!isValidEmail(email) || isResetLoading}
                                    className="kav-step-actions__btn kav-step-actions__btn--primary"
                                    type="submit"
                                >
                                    {isResetLoading && <span className="kav-spinner kav-spinner--light" aria-hidden="true"></span>}
                                    {isResetLoading ? "Versturen..." : "Resetlink versturen"}
                                    {!isResetLoading && <i className="bi bi-chevron-right" aria-hidden="true"></i>}
                                </button>
                            </div>
                    }
                </div>
            </form>
        </div>
    )
}

export default ReservationLoginPanel